<template>
  <div class="wrapper">
    <BasicLayout v-if="isRouterAlive1">
      <div class="container" :style="{ minHeight: `${height}px` }">
        <transition name="move" mode="out-in">
          <router-view v-if="isRouterAlive" :viewHeight="height"></router-view>
        </transition>
      </div>
    </BasicLayout>
  </div>
</template>
<script>
import BasicLayout from '../BasicLayout'
export default {
  components: {
    BasicLayout
  },
  provide () {
    return {
      reload: this.reload,
      reload1: this.reload1
    }
  },
  data () {
    return {
      height: 800,
      isRouterAlive: true,
      isRouterAlive1: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    reload1 () {
      this.isRouterAlive1 = false
      this.$nextTick(function () {
        this.isRouterAlive1 = true
      })
    }
  },
  created () {
    this.height = window.innerHeight - 324
  }
}
</script>

<style lang="less" scoped>
.container {
  background: #f4f5f6;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Home.vue